import { TestQuestion } from '../../components';
const TestQuestions = () => {
    return (
        <>
           <TestQuestion />
        </>
    )
}
export default TestQuestions;